import { render, staticRenderFns } from "./serverError.vue?vue&type=template&id=0f492849&scoped=true"
import script from "./serverError.vue?vue&type=script&lang=js"
export * from "./serverError.vue?vue&type=script&lang=js"
import style0 from "./serverError.vue?vue&type=style&index=0&id=0f492849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f492849",
  null
  
)

export default component.exports